import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.112 5.208a.534.534 0 00.045.704l2.088 2.09-2.089 2.087a.534.534 0 00.377.91l.07-.004a.527.527 0 00.307-.15L8 8.754l2.089 2.09a.531.531 0 00.753 0l.045-.05a.532.532 0 00-.044-.705L8.754 8l2.088-2.089a.535.535 0 000-.755l-.05-.044a.534.534 0 00-.705.045l-2.088 2.09-2.087-2.09a.533.533 0 00-.755 0l-.045.05z"
        fill="#A6A8AA"
      />
    </svg>
  );
}

export default SvgComponent;
